<script setup>
import DialogDrawer from '@js/components/dialogs/DialogDrawer.vue';
import ComboboxField from '@js/components/fields/ComboboxField.vue';
import FormColumn from '@js/components/forms/FormColumn.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import FormFooter from '@js/components/forms/FormFooter.vue';
import FormRoot from '@js/components/forms/FormRoot.vue';
import { useRoute } from '@js/utils/route';
import { reactive, ref, watch } from 'vue';
import { array, object } from 'yup';

const { server, callback } = defineProps({
    server: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const isOpen = ref(false);

const loading = ref(false);

const isSubmitting = ref(false);

const tenants = ref([]);

const form = reactive({
    tenants: [],
});

const validationSchema = object({
    tenants: array().of(object()).min(1),
});

watch(isOpen, (value) => {
    if (value) {
        updateData();
    }
});

function updateData() {
    loading.value = true;

    axios
        .post(
            route('front.projectManagement.dev.postTenantsByServer', {
                server: server.id,
            }),
        )
        .then((response) => {
            tenants.value = [...response.data];
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

function submit() {
    isSubmitting.value = true;

    axios
        .post(
            route('front.projectManagement.dev.postAddTenantsToServer', {
                server: server.id,
            }),
            {
                tenantIds: form.tenants.map((tenant) => tenant.id),
            },
        )
        .then(() => {
            isOpen.value = false;

            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            isSubmitting.value = false;
        });
}
</script>

<template>
    <DialogDrawer v-model="isOpen" :loading="loading">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title>
            Ajouter des clients au serveur {{ server.name }}
        </template>

        <template #full-content>
            <FormRoot
                :validation-schema="validationSchema"
                :submit="submit"
                v-slot="{ errors }"
            >
                <FormColumn>
                    <FormContent>
                        <ComboboxField
                            v-model="form.tenants"
                            field-id="tenants"
                            field-name="tenants"
                            label="Clients"
                            :options="tenants"
                            filtered-option-key="name"
                            required
                            multiple
                        >
                            <template #optionContent="{ option }">
                                {{ option.name }}
                            </template>
                        </ComboboxField>
                    </FormContent>
                </FormColumn>

                <FormFooter
                    :is-submitting="isSubmitting"
                    :errors="errors"
                    without-back-button
                />
            </FormRoot>
        </template>
    </DialogDrawer>
</template>
